import { EFdrProductType } from 'fdr/components/local/fdr-product-card/fdr-product-card.types';

export const fdrProductClassDictionary: {
  [key in EFdrProductType]: { icon: string; title: string };
} = {
  [EFdrProductType.Apartment]: {
    title: 'common:apartments',
    icon: 'appartments',
  },
  [EFdrProductType.Roundtrip]: {
    title: 'common:roundtrip',
    icon: 'rundreisen',
  },
  [EFdrProductType.Cruise]: { title: 'common:cruise', icon: 'cruise' },
  [EFdrProductType.Hotel]: {
    icon: 'hotel',
    title: 'common:hotel',
  },
};
